import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {GlobalStyle} from '../../styles';

import Apple from './../../assets/apple.svg';
import GooglePlay from './../../assets/google_play.svg';
import DownloadImage from './../../assets/downloadapp.png';
import {ReactComponent as CNLogo} from './../../assets/cn-logo.svg';

const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    min-height: 1000px;
    background-color: #000;
    z-index: 6;
    left: 0;
    right: 0;
    padding: 1rem;
    flex-direction: column;
    > img {
        max-width: 310px;
    }
`;
const Row = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    margin-bottom: 0.5em;
`;

const FakeHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 2rem;
`;

const TitleRow = styled(Row)`
    margin-bottom: 0.5rem;
`;

const Device = styled.div`
    margin-bottom: 1rem;
`;

const Title = styled.h2`
    font-size: 21px;
    line-height: 31px;
`;

const Description = styled.p`
    margin: 0;
    font-size: ${props => (props.small ? '12px' : '16px')};
    line-height: ${props => (props.small ? '19px' : '24px')};
    font-weight: normal;
    color: #e6e5e6;
`;

const DownloadApp = () => {
    const {t} = useTranslation();

    return (
        <Container>
            <GlobalStyle />
            <FakeHeader>
                <CNLogo title="Cartoon Network" width="99px" height="58px" />
            </FakeHeader>
            <TitleRow>
                <Title>{t('downloadApp.title')}</Title>
                <Description>{t('downloadApp.text1')}</Description>
                <Description>{t('downloadApp.text2')}</Description>
            </TitleRow>
            <Row>
                {/* eslint-disable max-len */}
                <Device>
                    {!!navigator.platform &&
                    /iPad|iPhone|iPod/.test(navigator.platform) ? (
                        <a
                            href="https://apps.apple.com/us/app/cartoon-network-já/id1290928633"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={Apple}
                                width="135px"
                                height="41px"
                                alt="Get it on AppStore"
                            />
                        </a>
                    ) : (
                        <a
                            href="https://play.google.com/store/apps/details?id=com.turner.cnja.br"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={GooglePlay}
                                width="135px"
                                height="41px"
                                alt="Get it on GooglePlay"
                            />
                        </a>
                    )}
                </Device>
            </Row>
            <img width="100%" src={DownloadImage} alt="Available devices" />
            <Row>
                <Description>{t('downloadApp.text3')}</Description>
            </Row>
        </Container>
    );
};

export default DownloadApp;
